import { contactPickerYourContacts } from './ContactPickerPane.locstring.json';
import loc from 'owa-localize';
import populateContactPicker from '../actions/populateContactPicker';
import { observer } from 'mobx-react';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { List } from 'office-ui-fabric-react/lib/List';
import FindRecipient from 'owa-recipient-common/lib/components/FindRecipient';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';

import * as React from 'react';
import { getExtendedTheme } from 'owa-fabric-theme';
import { ITheme } from '@uifabric/styling';
import store from '../store/contactPickerStore';

let styles = require('./ContactPickerPane.scss');
let classNames = require('classnames/bind').bind(styles);

export interface ContactPickerPaneProps {
    findControlGetter: () => HTMLElement;
    dismissContactPickerAction: () => void;
    addRecipientAction: (recipientToAdd: FindRecipientPersonaType) => void;
    theme?: ITheme;
}

@observer
export default class ContactPickerPane extends React.Component<ContactPickerPaneProps, any> {
    private dismissContactPicker = () => {
        this.props.dismissContactPickerAction();
    };

    private onLayerMounted() {
        if (store.maxForSession != store.contacts.length) {
            populateContactPicker();
        }
    }

    private renderSingleContact = (item?: any, index?: number) => {
        let { theme = getExtendedTheme() } = this.props;
        let contact = item as FindRecipientPersonaType;
        if (contact.EmailAddress) {
            return (
                <FindRecipient
                    key={contact.EmailAddress.EmailAddress}
                    findRecipient={contact}
                    isHighlighted={false}
                    addRecipientAction={this.props.addRecipientAction}
                    theme={theme}
                />
            );
        } else {
            return null;
        }
    };

    render() {
        let { findControlGetter, theme = getExtendedTheme() } = this.props;
        return (
            <Callout
                className={styles.callout}
                gapSpace={10}
                onDismiss={this.dismissContactPicker}
                onLayerMounted={this.onLayerMounted}
                target={findControlGetter()}
                isBeakVisible={false}
                setInitialFocus={false}
                directionalHint={DirectionalHint.bottomLeftEdge}>
                <div className={styles.suggestedContactsHeaderBox}>
                    <span
                        className={styles.suggestedContactsText}
                        style={{ color: theme.palette.themePrimary }}>
                        {loc(contactPickerYourContacts)}
                    </span>
                </div>
                {store.contacts.length != 0 && (
                    <div
                        className={classNames(styles.scrollContainer, 'customScrollBar')}
                        data-is-scrollable={true}>
                        <List items={store.contacts} onRenderCell={this.renderSingleContact} />
                    </div>
                )}
            </Callout>
        );
    }
}
